import brands from "./brands";
import categories from "./categories";
import delivery from "./delivery";
import products from "./products";
import pins from "./pins";
import giftcards from "./giftcards";
import orders from "./orders";

export default {
    brands,
    categories,
    delivery,
    products,
    pins,
    giftcards,
    orders,
}
